document.addEventListener( 'DOMContentLoaded', function () {
	document.querySelectorAll( '[data-contact-map]' ).forEach( function ( el ) {
		const lat  = parseFloat( el.dataset.lat );
		const lng  = parseFloat( el.dataset.lng );
		const zoom = parseFloat( el.dataset.zoom ) || 16;

		const map = L.map( el, { scrollWheelZoom: false } ).setView( [ lat, lng ], zoom );

		L.tileLayer( 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
			attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/">CARTO</a>',
			maxZoom: 19,
		} ).addTo( map );

		const icon = L.divIcon( {
			className: '',
			html: '<div style="width:14px;height:14px;background:#5e634a;border:2px solid #b59a62;border-radius:50%;box-shadow:0 0 0 4px rgba(94,99,74,.2);"></div>',
			iconSize: [ 14, 14 ],
			iconAnchor: [ 7, 7 ],
		} );

		L.marker( [ lat, lng ], { icon } ).addTo( map );
	} );
} );
